var app = angular.module('leonardo');

let SubCategoryRestService = function(BaseRestService) {
  return new BaseRestService('subcategories');
};

app.factory('SubCategoryRestService', ['BaseRestService', 'Restangular', SubCategoryRestService]);
